import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { AdminService } from '../../admin.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-req-report-template',
  templateUrl: './req-report-template.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [MatSelectModule, FormsModule, MatButtonModule],
})
export class ReqReportTemplateComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  @Input() reportTemplates;
  selectedRequestReport: string;
  selectedRequestReportStatus: string;
  selectedRequestReportStatusClass: string;
  selectedRequestReportTemplate: string;

  requestReportTemplate() {
    this.toggleLoading.emit();
    this.selectedRequestReportStatus = null;
    this.selectedRequestReportStatusClass = null;

    const data = `{"test": "GetTemplate","name": "${this.selectedRequestReportTemplate}"}`;

    this.admnSrvc.requestReportTemplate(data).subscribe({
      next: res => {
        this.toggleLoading.emit();
        this.selectedRequestReportStatus = 'Success';
        this.selectedRequestReportStatusClass = 'success';
        this.selectedRequestReport = `${res}`;
      },
      error: catchError(err => {
        this.toggleLoading.emit();
        this.selectedRequestReportStatus = err;
        this.selectedRequestReportStatusClass = 'failure';
        return throwError(() => err.error || 'Server error');
      }),
    });
  }
}
